<template>
    <div class="cupon-contenido">
        <div class="puedes-usar-cupon">
            <p v-if="visible('descuento')" class="descuento">{{ detail.descuento }}</p>
            <p v-if="visible('observacion_descuento')" class="observacion" v-html="detail.observacion_descuento"></p>
            <template v-if="visible('uso')">
                <p class="uso">Puedes usar este cupón:</p>
                <div class="canales">
                    <img src="../assets/btn-en-tienda.png" v-if="uso.includes('tienda')" alt="En tienda"/>
                    <img src="../assets/btn-en-linea.png" v-if="uso.includes('línea')" alt="En línea"/>
                    <img src="../assets/btn-en-telefono.png" v-if="uso.includes('telefono')" alt="Por teléfono"/>
                    <img src="../assets/btn-whatsapp.png" v-if="uso.includes('whatsapp')" alt="WhatsApp"/>
                    <img src="../assets/btn-en-correo.png" v-if="uso.includes('correo')" alt="Por correo"/>
                </div>
                <button v-if="!cuponAlreadyDownloaded" class="quiero-cupon" type="button" :disabled="preview" @click="$emit('quiero-cupon')">
                    <img src="../assets/quiero-este-cupon.png" alt="Quiero este cupón"/>
                </button>
            </template>
            <button class="favorite-icon" type="button" :disabled="preview" :aria-label="favorited ? 'Quitar de favoritos' : 'Agregar a favoritos'" @click="$emit('favorito')">
                <img :src="favorited ? require('../assets/favorite-ok.png') : require('../assets/favorite.png')" alt=""/>
            </button>
        </div>
        <div class="cupon-info">
            <p v-if="visible('texto_personalizado') && textoPersonalizado1" class="texto-personalizado">{{ textoPersonalizado1 }}</p>
            <a v-if="visible('boton_personalizado') && detail.boton_personalizado_titulo && enlacePersonalizado"
                class="boton-personalizado" :href="enlacePersonalizado" target="_blank" rel="noopener noreferrer">{{ detail.boton_personalizado_titulo }}</a>
            <p v-if="visible('texto_personalizado_2') && textoPersonalizado2" class="texto-personalizado">{{ textoPersonalizado2 }}</p>
            <a v-if="visible('boton_personalizado_2') && detail.boton_personalizado_titulo_2 && enlacePersonalizado2"
                class="boton-personalizado" :href="enlacePersonalizado2" target="_blank" rel="noopener noreferrer">{{ detail.boton_personalizado_titulo_2 }}</a>
            <template v-if="visible('instrucciones') && detail.instrucciones">
                <h2>Instrucciones de uso</h2>
                <div class="texto-html" v-html="detail.instrucciones"></div>
            </template>
            <template v-if="visible('sobre_la_marca') && detail.sobre_la_marca">
                <h2>Sobre {{ detail.marca_grupo }}</h2>
                <div class="texto-html" v-html="detail.sobre_la_marca"></div>
            </template>
            <template v-if="visible('terminos_y_condiciones') && detail.terminos_y_condiciones">
                <h2>Términos y condiciones</h2>
                <div class="texto-html" v-html="detail.terminos_y_condiciones"></div>
            </template>
            <h2>Información adicional</h2>
        </div>
        <div class="info-adicional">
            <a v-if="detail.facebook" :href="detail.facebook" target="_blank" rel="noopener noreferrer"><img src="../assets/facebook.png" alt="Facebook"/></a>
            <a v-if="detail.instagram" :href="detail.instagram.includes('http') ? detail.instagram : 'https://www.instagram.com/'+detail.instagram.replace('@', '')" target="_blank" rel="noopener noreferrer"><img src="../assets/instagram.png" alt="Instagram"/></a>
            <div v-if="contactoVisible" v-html="linkify(detail.telefono_liga_correo)"></div>
        </div>
        <slot v-if="visible('coordenadas')" name="mapa"></slot>
    </div>
</template>

<script>
import { esVisible, enlaceWebSeguro } from '../shared/cuponPresentacion';
export default {
    name: 'CuponContenido',
    props: {
        detail: { type: Object, required: true },
        favorited: Boolean,
        cuponAlreadyDownloaded: Boolean,
        preview: Boolean,
    },
    emits: ['quiero-cupon', 'favorito'],
    computed: {
        uso() { return String(this.detail.uso || '').toLowerCase(); },
        textoPersonalizado1() { return String(this.detail.texto_personalizado || '').trimEnd(); },
        textoPersonalizado2() { return String(this.detail.texto_personalizado_2 || '').trimEnd(); },
        enlacePersonalizado() { return enlaceWebSeguro(this.detail.boton_personalizado_url); },
        enlacePersonalizado2() { return enlaceWebSeguro(this.detail.boton_personalizado_url_2); },
        contactoVisible() { return !['', 'na', 'n/a'].includes(String(this.detail.telefono_liga_correo || '').toLowerCase()); },
    },
    methods: {
        visible(campo) { return esVisible(this.detail, campo); },
        linkify(text) {
            return String(text || '').replace(/(https?:\/\/[^\s]+)/g, url => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
        },
    },
};
</script>

<style scoped>
.cupon-contenido { width: 100%; background: white; color: #061283; font-family: 'Benton Sans BBVA book', sans-serif; display: flex; flex-direction: column; align-items: center; overflow-wrap: anywhere; }
.puedes-usar-cupon { width: calc(100% - 2ch); position: relative; display: flex; flex-direction: column; }
.descuento { font-family: 'Benton Sans BBVA bold', sans-serif; font-style: italic; margin: .75ch 0 0; padding-right: 1ch; color: black; font-size: 3.25ch; }
.observacion { margin: 1.4ch 0 0; color: black; font-size: 1.4ch; }
.uso { color: gray; font-size: 1.4ch; }
.canales { display: flex; align-items: center; flex-wrap: wrap; }
.canales img { height: 2.5ch; margin-right: 1ch; }
.quiero-cupon { background: none; border: 0; padding: 0; height: 3ch; width: 11ch; margin-top: 1ch; font: inherit; cursor: pointer; }
.quiero-cupon img { height: 100%; width: 100%; }
.favorite-icon { position: absolute; width: 3ch; top: 1ch; right: 0; background: none; border: 0; padding: 0; font: inherit; cursor: pointer; }
.favorite-icon img { width: 100%; }
.cupon-info { width: calc(100% - 2ch); }
.cupon-info h2 { font-family: 'Benton Sans BBVA bold', sans-serif; margin-bottom: .25ch; }
.texto-html { margin: 0 0 1em; }
.texto-html :deep(p) { margin-top: 0; }
.cupon-info .texto-personalizado { font-size: 2em; white-space: pre-wrap; margin: 1em 0 0; line-height: 1.4; }
.cupon-info .texto-personalizado + .boton-personalizado { margin-top: 0; }
.boton-personalizado { display: inline-flex; align-items: center; justify-content: center; box-sizing: border-box; min-width: 11ch; min-height: 3ch; max-width: 100%; padding: .5em 1em; margin: .5em 0; font-size: 2em; font-family: 'Benton Sans BBVA bold', sans-serif; text-align: center; text-decoration: none; text-transform: uppercase; color: white; background: #100b80; border-radius: .3em; box-shadow: 0 2px 4px #0005; }
.boton-personalizado:hover, .quiero-cupon:hover { filter: brightness(1.1); }
.boton-personalizado:focus-visible, button:focus-visible { outline: 3px solid #1e88e5; outline-offset: 3px; }
.info-adicional { width: calc(100% - 2ch); margin: 1ch 0; }
.info-adicional img { width: 4ch; margin-right: 2ch; }
</style>
